/**
 * Coupon type of the bond.
 * tag: 1946
 * @readonly
 * @enum {number} (int)
 */
export enum CouponType {
  /** Zero */
  Zero = 0,
  /** Fixed rate */
  FixedRate = 1,
  /** Floating rate */
  FloatingRate = 2,
  /** Structured */
  Structured = 3,
}
